import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
} from '@mui/material';
import { useForm, Controller } from 'react-hook-form';

import { useEscalarTicket } from '@/shared/actions/erp/tickets-soporte-cliente';
import { useFetchTicketAreas } from '@/shared/actions/erp/tickets-soporte-cliente/gestion-tickets-catalogos.actions';

type ModalEscalarProps = {
  open: boolean;
  onClose: () => void;
  ticketId: string;
};

type FormData = {
  area_destino: string;
  comentario: string;
};

export default function ModalEscalar({ open, onClose, ticketId }: ModalEscalarProps) {
  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormData>({
    defaultValues: { area_destino: '', comentario: '' },
  });

  const { data: areasData, isLoading: isLoadingAreas } = useFetchTicketAreas();
  const escalarTicket = useEscalarTicket();

  const areas = (areasData?.data as any)?.data ?? areasData?.data ?? [];

  const onSubmit = (data: FormData) => {
    escalarTicket.mutate(
      { id: ticketId, data },
      {
        onSuccess: () => {
          reset();
          onClose();
        },
      }
    );
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Escalar Ticket</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 2 }}>
        <Controller
          name="area_destino"
          control={control}
          rules={{ required: 'El area destino es requerida' }}
          render={({ field }) => (
            <TextField
              {...field}
              select
              label="Area Destino"
              fullWidth
              size="small"
              error={!!errors.area_destino}
              helperText={errors.area_destino?.message}
              disabled={isLoadingAreas}
              sx={{ mt: 1 }}
            >
              {areas.map((area: any) => (
                <MenuItem key={area.id_area} value={area.id_area}>
                  {area.nombre}
                </MenuItem>
              ))}
            </TextField>
          )}
        />
        <TextField
          {...register('comentario', { required: 'El comentario es requerido' })}
          label="Comentario"
          multiline
          minRows={3}
          fullWidth
          size="small"
          error={!!errors.comentario}
          helperText={errors.comentario?.message}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit">
          Cancelar
        </Button>
        <Button
          onClick={handleSubmit(onSubmit)}
          variant="contained"
          disabled={escalarTicket.isPending}
        >
          Escalar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
